import { Flex, Modal, ScrollArea, Text } from "@mantine/core";

import type { Language } from "../language-selector/useLanguageStore";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { useProductOfferStore } from "../../../../stores";
import { GreenQuote } from "../Icons";
import { DisclosuresMap } from "./disclosuresMap";
import classes from "./FTCDisclosureModal.module.css";
import { InfoIcon } from "./PurpleInfo";

export const FTCDisclosureModal = ({
    opened,
    close,
    productSku,
    language,
    requiresNyDisclosures,
}: {
    opened: boolean;
    close: () => void;
    productSku: string;
    language: Language;
    requiresNyDisclosures: boolean;
}) => {
    const { sessionId } = useSalesContext();
    const productInfo = useProductOfferStore.getState().getProductInfo(sessionId, productSku, language);

    return (
        <Modal
            centered
            size="auto"
            opened={opened}
            onClose={close}
            title={`${productInfo?.displayName}\nlegal disclosures`}
            classNames={{
                title: classes.title,
                header: classes.header,
            }}
            zIndex="var(--mantine-priority-highest)"
        >
            <Flex w="28.5rem">
                <Flex direction="column">
                    <ScrollArea
                        h={300}
                        classNames={{ root: classes.scrollRoot, scrollbar: classes.scrollBar }}
                        type="hover"
                    >
                        <GreenQuote />
                        <Text size="sm" mb="md">
                            <DisclosuresMap
                                requiresNyDisclosures={requiresNyDisclosures}
                                FTCDisclosures={productInfo?.ftcDisclosures}
                            />
                        </Text>
                        <Flex className={classes.fade} h={36} w="456px" />
                    </ScrollArea>
                    <Flex bg="primary.0" className={classes.box} p="sm" direction="row" gap="md">
                        <InfoIcon width={16} height={16} />
                        <Flex>
                            <Text span c="primary.9" size="xs" fw={700}>
                                This is the customer view.{" "}
                                <Text span c="primary.9" size="xs" fw={400}>
                                    {`You can use this text to help answer the customer\u2019s questions`}{" "}
                                </Text>
                            </Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Modal>
    );
};
